import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=c1c8dfba&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
import style0 from "./Register.vue?vue&type=style&index=0&id=c1c8dfba&prod&lang=scss&scoped=true"
import style1 from "./Register.vue?vue&type=style&index=1&id=c1c8dfba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c8dfba",
  null
  
)

export default component.exports